// chartConfig.js
const chartBaseConfig = {
  fontFamily: "SF Pro Display, sans-serif",
  fontSize: 10,
  titleFontSize: 14,
  titleFontWeight: 500,
  titleColor: "#333",
  gridColor: "#f0f0f0",
  lineColor: "#0046ad",
  axisLabelFontColor: "#333",
    fontWeight: '500'
};



export const applyBaseConfig = (chart) => {
  chart.xAxis().labels().fontFamily(chartBaseConfig.fontFamily).fontSize(chartBaseConfig.fontSize).fontColor(chartBaseConfig.axisLabelFontColor).fontWeight(chartBaseConfig.fontWeight);
  chart.yAxis().labels().fontFamily(chartBaseConfig.fontFamily).fontSize(chartBaseConfig.fontSize).fontColor(chartBaseConfig.axisLabelFontColor).fontWeight(chartBaseConfig.fontWeight);
  chart.xAxis().stroke(chartBaseConfig.gridColor);
  chart.yAxis().stroke(chartBaseConfig.gridColor);
  chart.xAxis().title().fontFamily(chartBaseConfig.fontFamily).fontSize(12).fontColor(chartBaseConfig.axisLabelFontColor).fontWeight('500');
  chart.yAxis().title().fontFamily(chartBaseConfig.fontFamily).fontSize(12).fontColor(chartBaseConfig.axisLabelFontColor).fontWeight('500');
  chart.background().fill("#fff");
};



export const applyBarConfig = (chart, title, {enabled=true}={}) => {
  applyBaseConfig(chart, title);
  chart.xGrid({
    enabled: false,
  });
  chart.xMinorGrid({
      enabled: false,
  });
  chart.yGrid({
      enabled: true,
      stroke: '#f0f0f0'
  });
  chart.yMinorGrid({
      enabled: enabled,
      stroke: '#f1f1f1'
    });
}

export default chartBaseConfig;
